import { store } from '@/store';
import pushNotificationService from '@/services/pushNotifications/pushNotification.service';
import requireCustomerLogin from '../require-customer-login/require-customer-login';

function pushNotificationsEnabled(
  enabledPlatforms,
  webPushConfig,
  publicVapidKey,
  customerKey,
  isEmployee,
) {
  try {
    return pushNotificationService.isPushNotificationsSupported(
      enabledPlatforms,
      webPushConfig,
      publicVapidKey,
      customerKey,
      isEmployee,
    );
  } catch (error) {
    console.debug('Push Notifications are not supported:', error);
    return false;
  }
}

/**
 * Reject notification access if it's not enabled
 * @param {*} to destination
 * @param {*} from source
 * @param {*} next next route
 */
export default async function notificationAccess(to, from, next) {
  const isCustomer = store.getters['user/isCustomer'];
  const isEmployee = store.getters['user/isEmployee'];

  const isNotificationsEnabled = pushNotificationsEnabled(
    store.getters.getConfiguration.enabledPlatforms,
    store.getters.getConfiguration.webPushConfig,
    store.getters.getConfiguration.publicVapidKey,
    isCustomer,
    isEmployee,
  );

  if (!isCustomer && isNotificationsEnabled) {
    requireCustomerLogin(to, from, next);
  } else if (!isNotificationsEnabled) {
    next({ name: 'NotFound' });
  } else {
    next();
  }
}
